import { BANCA_JOURNEY, SAMS_JOURNEY } from "constants/Constants";
import getCookieValue from "./getCookieValue/getCookieValue";

const isReverseApiCall = () => {
    let channel_code = document.cookie.split("; ").find((row) => row.startsWith("channel_code="))?.split("=")[1];
    let source_system = getCookieValue("source")
    let channelCodeList = ["CSB", "COA", "OA"]

    if ((channelCodeList.includes(channel_code)) && (source_system !== SAMS_JOURNEY && source_system !== BANCA_JOURNEY)) {
        return true
    } else {
        return false
    }
}
export default isReverseApiCall;